import { useState } from "react";
import { format } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { CalendarBlank } from "@phosphor-icons/react";

export default function DateRangeFilter({ dateRange, onDateRangeChange }) {
  const [fromOpen, setFromOpen] = useState(false);
  const [toOpen, setToOpen] = useState(false);

  return (
    <div
      data-testid="date-range-filter"
      className="flex items-center gap-2 text-xs"
    >
      <span className="text-zinc-500 font-mono">From</span>
      <Popover open={fromOpen} onOpenChange={setFromOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="border-zinc-700 bg-zinc-900 hover:bg-zinc-800 font-mono text-xs h-8 gap-1.5 min-w-[130px]"
            data-testid="date-from-btn"
          >
            <CalendarBlank size={14} weight="duotone" className="text-zinc-400" />
            {dateRange.from
              ? format(dateRange.from, "MM-dd-yyyy")
              : "Start date"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-zinc-900 border-zinc-800" align="start">
          <Calendar
            mode="single"
            selected={dateRange.from}
            onSelect={(date) => {
              onDateRangeChange({ ...dateRange, from: date });
              setFromOpen(false);
            }}
            initialFocus
          />
        </PopoverContent>
      </Popover>

      <span className="text-zinc-500 font-mono">To</span>
      <Popover open={toOpen} onOpenChange={setToOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="border-zinc-700 bg-zinc-900 hover:bg-zinc-800 font-mono text-xs h-8 gap-1.5 min-w-[130px]"
            data-testid="date-to-btn"
          >
            <CalendarBlank size={14} weight="duotone" className="text-zinc-400" />
            {dateRange.to
              ? format(dateRange.to, "MM-dd-yyyy")
              : "End date"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-zinc-900 border-zinc-800" align="start">
          <Calendar
            mode="single"
            selected={dateRange.to}
            onSelect={(date) => {
              onDateRangeChange({ ...dateRange, to: date });
              setToOpen(false);
            }}
            initialFocus
          />
        </PopoverContent>
      </Popover>

      {(dateRange.from || dateRange.to) && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onDateRangeChange({ from: null, to: null })}
          className="text-zinc-500 hover:text-zinc-300 text-xs h-8 px-2"
          data-testid="date-clear-btn"
        >
          Clear
        </Button>
      )}
    </div>
  );
}
